module.exports = __webpack_public_path__ + "img/send.cbfa6685.svg";